<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">เลือก Method</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">

                <b-input v-model="searchName"></b-input>
                <!--                :paginated=true-->
                <!--                :per-page="perPage"-->
                <!--                :current-page.sync="currentPage"-->
                <b-table
                        :data="filterMstMethodDat"
                        :bordered=false
                        :striped=false
                        narrowed
                        :hoverable=false
                        :focusable=false
                        mobile-cards>
                    <b-table-column   label="No."  v-slot="props"  >
                        {{props.index +1 }}
                    </b-table-column>
                    <b-table-column   label="Name"  v-slot="props"  >
                        <text-highlight :queries="queries">{{ props.row.name }}</text-highlight>
                    </b-table-column>
                    <b-table-column   label="#"  v-slot="props"  >
                        <b-button type="is-success" size="is-medium" outlined icon-left="check"   @click="pickupMethod(props.row.id)">
                            เลือก
                        </b-button>
                    </b-table-column>
                </b-table>

            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "SelectMethod",
        computed:{
            ...mapState({
                mstMethod: state => state.bact.mstMethod,
            }),

            filterMstMethodDat: function () {

                const tmp = this.mstMethod.filter((MethodDat)=>{
                    // console.log(listOfUser.id_auth_group)
                    return MethodDat.name.toUpperCase().indexOf(this.searchName.toUpperCase()) > -1
                })

                return tmp
            },
            queries(){
                return this.searchName.split(" ");
            }
        },
        methods:{
            closeBtn(){
                this.$emit('closeSelectMethod')
            },
            pickupMethod(_id){
                // console.log(_id)
                this.$emit('closeSelectMethodWithPickData',{id : _id})
            }
        },
        data(){
            return{
                searchName : '',
            }
        }
    }
</script>

<style scoped>

</style>